var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale1G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 124,
    viewBox: "0 0 129 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Male 1 G"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 106",
    cx: 60.0357,
    cy: 61.5,
    rx: 60.0357,
    ry: 61.5,
    fill: "#E0DDFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1",
    filter: "url(#filter0_f_293_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 13.5L114 35.5L117.396 48.1802C124.263 73.8136 113.281 100.89 90.5 114.5L68 107V13.5Z",
    fill: "#858181",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 91",
    d: "M81.7506 42.7115C81.8378 42.0079 81.8052 41.3176 81.7051 40.6871C81.3932 38.722 79.5548 38.5321 77.9811 39.7497C77.4314 40.175 76.9604 40.6934 76.5895 41.2813L75 43.8008L74.5 52.3008L74.5325 52.291C75.1409 52.108 75.8 52.225 76.3083 52.6062L76.849 53.0117C77.2353 53.3015 78.1067 53.0271 78.5402 52.8145C78.8694 52.6531 78.8053 52.5761 79.0075 52.2702L79.3264 51.788C79.4088 51.6634 79.4781 51.5306 79.5332 51.3918L80.2171 49.6682C80.6005 48.3799 81.4439 45.185 81.7506 42.7115Z",
    fill: "#F4B09D",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 97",
    d: "M34.5502 42.7115C34.463 42.0079 34.4955 41.3176 34.5956 40.6871C34.9076 38.722 36.746 38.5321 38.3197 39.7497C38.8694 40.175 39.3404 40.6934 39.7113 41.2813L41.3008 43.8008L41.8008 52.3008L41.7683 52.291C41.1599 52.108 40.5008 52.225 39.9925 52.6062L39.4518 53.0117C39.0655 53.3015 38.1941 53.0271 37.7606 52.8145C37.4313 52.6531 37.4955 52.5761 37.2933 52.2702L36.9744 51.788C36.892 51.6634 36.8227 51.5306 36.7676 51.3918L36.0837 49.6682C35.7003 48.3799 34.8569 45.185 34.5502 42.7115Z",
    fill: "#F4B09D",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 93",
    d: "M44.8535 76.8356V63.5371L71.3061 63V65.1659V71.8114V77.6086V80.1898C71.3061 81.301 71.2069 82.4099 71.0097 83.5034L70.9004 84.1092C70.6609 85.4372 70.2351 86.7247 69.6355 87.9336L69.3332 88.5431C68.6124 89.9964 67.5853 91.2763 66.3225 92.2947C65.0595 93.3133 63.5907 94.0462 62.0172 94.4427L61.4343 94.5896C60.3522 94.8623 59.2406 95.0003 58.1247 95.0003H57.4498C55.4777 95.0003 53.5414 94.4731 51.8414 93.4734C50.5198 92.6962 49.3741 91.6528 48.4771 90.4094L47.8594 89.5531C47.1358 88.5502 46.5318 87.4663 46.0594 86.3234C45.2632 84.3971 44.8535 82.3332 44.8535 80.2489V76.8356Z",
    fill: "#F6C4A9",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 90",
    d: "M41.0427 55.1641L40.6716 53.8279C40.1382 51.9074 39.7542 49.9484 39.5232 47.9686L39.1035 44.3726V40.1213V39.7978C39.1035 36.6692 39.36 33.5459 39.8703 30.4593L40.637 27.7539L40.854 26.806C41.4639 24.1417 42.8073 21.7012 44.7321 19.7607C45.577 18.909 46.5233 18.1644 47.5497 17.5435L47.7675 17.4118C50.3759 15.834 53.3662 15 56.4147 15H58.2721H62.7371C64.3491 15 65.9494 15.274 67.4696 15.8104C70.9169 17.0268 73.7635 19.5238 75.4187 22.7832L75.7025 23.3422C76.0938 24.1128 76.4212 24.9142 76.6814 25.7383L76.9381 26.5516C77.9693 29.8187 78.3487 33.2566 78.0547 36.6699L77.824 39.3483L76.6739 50.9428L76.2905 53.6481C75.526 56.7309 74.4285 59.7213 73.0173 62.5666L72.8401 62.9237L70.3494 66.5506C69.7118 67.4792 68.9705 68.3322 68.1401 69.0933C66.1969 70.8742 63.8149 72.1061 61.2384 72.6627L60.8635 72.7437C60.1602 72.8956 59.4427 72.9722 58.7232 72.9722C55.4664 72.9722 52.32 71.7914 49.8675 69.6485L49.2356 69.0965C48.3619 68.3332 47.5756 67.4753 46.891 66.5387L45.8859 65.1636C43.6827 62.1492 42.0419 58.7616 41.0427 55.1641Z",
    fill: "#F6C4A9",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9128 60.2453L52.9068 61.762H62.8745L61.0594 60.1936C60.49 59.7016 59.8033 59.365 59.0656 59.2163C58.5423 59.1107 58.0041 59.102 57.4776 59.1905L57.2855 59.2227C56.4238 59.3675 55.6098 59.7183 54.9128 60.2453Z",
    fill: "url(#paint0_linear_293_1037)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9068 61.762L54.9128 60.2453C55.6098 59.7183 56.4238 59.3675 57.2855 59.2227L57.4776 59.1905C58.0041 59.102 58.5423 59.1107 59.0656 59.2163V59.2163C59.8033 59.365 60.49 59.7016 61.0594 60.1936L62.8745 61.762H52.5234",
    stroke: "#4F4848",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 94",
    d: "M55.5898 54.0332V54.0332C56.9467 55.7919 59.6002 55.7919 60.957 54.0332V54.0332",
    stroke: "#4F4848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 96",
    d: "M56.3535 63.3105L56.533 63.4915C57.4573 64.4233 58.988 64.3386 59.8039 63.3105V63.3105",
    stroke: "#4F4848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 109",
    d: "M80.8828 43.7169C80.8828 44.2692 80.3828 42.7168 79.8828 42.7175C79.3828 42.2168 78.748 42.2684 78.748 41.7161C78.748 41.1638 79.3828 40.717 79.8828 41.2174C80.4351 41.2174 80.8828 43.1646 80.8828 43.7169Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 110",
    d: "M77.5409 50.7164C77.3825 50.2168 77.7246 47.8711 77.8828 46.7168C77.8828 45.3711 78.5409 43.7168 79.0409 43.7168C80.0026 43.7168 79.9499 45.2251 79.7443 46.1645C79.329 48.0619 78.1838 50.7167 77.5409 50.7164Z",
    fill: "#6B6B6B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 116",
    d: "M38.4453 43.136C38.4453 47.6367 39.9453 49.6367 39.9449 50.636C39.4453 51.6367 36.9449 46.9122 36.9449 46.636C36.9449 46.3599 35.9436 43.6366 36.9453 42.136C37.9436 41.6365 38.447 42.6368 38.4453 43.136Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 113",
    opacity: 0.5,
    filter: "url(#filter1_f_293_1037)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 62.5,
    rx: 1,
    ry: 0.5,
    fill: "#DC2F2F",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top/_Resources/Round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lennon Glasses",
    filter: "url(#filter2_d_293_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1967 50.173C45.161 50.1056 41.9491 46.4755 42.0228 42.065C42.0363 41.2545 42.1599 40.474 42.3776 39.7404L39.5577 39.6932C39.0982 39.6856 38.732 39.3069 38.7397 38.8475C38.7474 38.3881 39.126 38.0218 39.5855 38.0295L42.7805 38.0829C42.8729 38.0845 42.9616 38.101 43.0442 38.1303C44.3424 35.7411 46.743 34.1558 49.4636 34.2013C52.3111 34.2489 54.7485 36.07 55.911 38.6875C56.5608 37.6614 57.6246 37.0004 58.816 37.0203C60.0376 37.0407 61.1012 37.7721 61.7096 38.864C62.9459 36.2435 65.4646 34.4687 68.3411 34.5168C71.062 34.5623 73.4085 36.2271 74.626 38.6588C74.7096 38.6323 74.7988 38.6187 74.8912 38.6203L77.1857 38.6586C77.6451 38.6663 78.0113 39.045 78.0036 39.5044C77.996 39.9638 77.6173 40.33 77.1579 40.3223L75.2382 40.2903C75.4312 41.0306 75.5286 41.8145 75.515 42.6247C75.4413 47.0352 72.1099 50.5559 68.0742 50.4885C64.0384 50.421 60.8265 46.791 60.9002 42.3805C60.9081 41.9074 60.9535 41.4445 61.0332 40.9952C61.0318 39.5387 60.0272 38.3719 58.7937 38.3513C57.656 38.3323 56.6803 39.2944 56.4964 40.5862C56.5984 41.1421 56.6474 41.7187 56.6376 42.3093C56.5639 46.7197 53.2325 50.2404 49.1967 50.173ZM49.219 48.842C52.5821 48.8982 55.3583 45.9643 55.4197 42.2889C55.4811 38.6135 52.8045 35.5885 49.4414 35.5323C46.0783 35.4761 43.3021 38.41 43.2407 42.0854C43.1793 45.7608 45.8558 48.7858 49.219 48.842ZM74.2971 42.6044C74.2357 46.2798 71.4595 49.2137 68.0964 49.1575C64.7333 49.1013 62.0567 46.0762 62.1181 42.4009C62.1795 38.7255 64.9557 35.7916 68.3188 35.8478C71.682 35.904 74.3585 38.929 74.2971 42.6044Z",
    fill: "#252C2F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 3",
    d: "M44.5 33.5L44.9566 33.363C47.9132 32.476 51.0716 32.5239 54 33.5V33.5",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 4",
    d: "M63 33.5L63.4566 33.363C66.4132 32.476 69.5716 32.5239 72.5 33.5V33.5",
    stroke: "black",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 117",
    d: "M71 66.0399C71 69.4867 67.2529 74.6671 61.0436 77.0586C58.9248 77.8746 56.5564 77.9135 54.433 77.1097C47.6976 74.5599 45 68.4954 45 65C46.0196 66.1774 50.6078 73.0842 57.2353 73.3194C64.8824 73.5909 68.9608 69.1597 71 66.0399Z",
    fill: "#655E5E",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 114",
    filter: "url(#filter3_f_293_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 94.9997C106 106 84.2978 123 60.1502 123C36.0026 123 17 107.501 10 93.0014C59 69.5 32.5 71.0009 57.5 93.0009C84 74.4997 52.5 67.4997 109 94.9997Z",
    fill: "#105F9A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5646 77.9825L42.7237 74.17C43.291 73.6499 44.2086 73.9388 44.3756 74.6902L44.9497 77.2735C44.9828 77.4225 45.0496 77.562 45.145 77.6812L51 85L57.5 89.5L63.5 85L71.2747 77.7112C71.4215 77.5736 71.5233 77.395 71.567 77.1986L72.0815 74.8832C72.2574 74.0918 73.2523 73.8276 73.7976 74.4274L77.0173 77.969C77.3058 78.2864 77.3598 78.7524 77.1515 79.1273L70.6848 90.7674C70.3502 91.3697 69.521 91.4611 69.0632 90.9461L66 87.5L57.5 93.5L48.8571 87.5L45.9647 90.8745C45.5033 91.4128 44.644 91.3134 44.3177 90.6841L38.3526 79.1799C38.1445 78.7787 38.2314 78.2878 38.5646 77.9825Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 85L48.8571 87.5M51 85L57.5 89.5M51 85L45.145 77.6812C45.0496 77.562 44.9828 77.4225 44.9497 77.2735L44.3756 74.6902C44.2086 73.9388 43.291 73.6499 42.7237 74.17L38.5646 77.9825C38.2314 78.2878 38.1445 78.7787 38.3526 79.1799L44.3177 90.6841C44.644 91.3134 45.5033 91.4128 45.9647 90.8745L48.8571 87.5M48.8571 87.5L57.5 93.5M57.5 93.5L66 87.5M57.5 93.5V89.5M66 87.5L69.0632 90.9461C69.521 91.4611 70.3502 91.3697 70.6848 90.7674L77.1515 79.1273C77.3598 78.7524 77.3058 78.2864 77.0173 77.969L73.7976 74.4274C73.2523 73.8276 72.2574 74.0918 72.0815 74.8832L71.567 77.1986C71.5233 77.395 71.4215 77.5736 71.2747 77.7112L63.5 85M66 87.5L63.5 85M63.5 85L57.5 89.5",
    stroke: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Hairt 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Short Hair",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3384 19.2581C74.3528 18.251 73.2084 17.3961 72.0953 16.5389C71.8497 16.3499 71.6002 16.1655 71.3601 15.9694C71.3055 15.9248 70.7463 15.5243 70.6794 15.3769C70.5184 15.0224 70.6117 15.2984 70.6339 14.8753C70.662 14.3403 71.753 12.8292 70.9389 12.4826C70.5807 12.3302 69.9419 12.7358 69.5983 12.8698C68.9264 13.132 68.2462 13.3556 67.5516 13.5484C67.8844 12.8852 68.5189 11.5578 67.3263 11.9131C66.3971 12.1899 65.5313 12.9015 64.5977 13.2363C64.9066 12.7299 66.142 11.1608 65.0257 11.0731C64.6783 11.0458 63.6674 11.6974 63.2934 11.8364C62.1732 12.2528 61.0289 12.5219 59.8527 12.7339C55.8535 13.4547 51.1767 13.2492 47.4766 15.0699C44.624 16.4736 41.8072 18.6516 40.1593 21.425C38.571 24.0982 37.977 27.0238 37.6445 30.087C37.4006 32.3351 37.3807 34.6589 37.4948 36.9151C37.5321 37.6543 37.6152 41.0619 38.6892 40.0299C39.2242 39.5157 39.2203 37.4395 39.355 36.7367C39.6232 35.3384 39.8813 33.9339 40.3285 32.5804C41.1164 30.1951 42.0459 27.6543 44.0088 26.0115C45.2684 24.9573 46.153 23.5326 47.3584 22.4691C47.8999 21.9915 47.4867 22.0412 48.3573 22.1039C48.9422 22.146 49.5297 22.162 50.1157 22.1774C51.4714 22.2126 52.8293 22.2036 54.1854 22.2084C56.9164 22.2182 59.6346 22.2568 62.363 22.1138C63.5755 22.0503 64.7913 22.0159 66.0005 21.9038C66.6761 21.8411 67.8747 21.4082 68.4308 21.739C68.9396 22.0417 69.4681 23.03 69.8335 23.4348C70.6968 24.3914 71.7262 25.122 72.7357 25.9064C74.8408 27.5419 75.9036 29.5961 76.5429 32.152C77.1799 34.6984 77.0013 37.0609 77.7897 39.5668C77.9284 40.0074 78.2952 40.7669 78.7475 40.0862C78.8315 39.9597 78.8097 39.2648 78.8097 38.8649C78.8097 37.2507 79.2185 36.0395 79.2134 34.4148C79.1933 29.4748 79.0336 23.0333 75.3384 19.2581Z",
    fill: "#1F3140"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_293_1037",
    x: 67,
    y: 12.5,
    width: 53.4238,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_293_1037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_293_1037",
    x: 56.6,
    y: 61.6,
    width: 2.8,
    height: 1.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_293_1037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_293_1037",
    x: 38.7402,
    y: 34.2012,
    width: 39.2637,
    height: 18.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_293_1037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_293_1037",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_293_1037",
    x: 9,
    y: 74.9336,
    width: 101,
    height: 49.0664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_293_1037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_293_1037",
    x1: 58.274,
    y1: 59.4431,
    x2: 58.274,
    y2: 62.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D1111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale1G);
export default __webpack_public_path__ + "static/media/Male 1 G.6f6aecc40e93b000b7b8516a7dd49b8b.svg";
export { ForwardRef as ReactComponent };